/**
 * src/components/auth/PublicOnlyRoute.tsx
 * =============================================================================
 * Guard para rutas públicas que NO deberían ver los usuarios ya autenticados
 * (login, signup). Si hay sesión activa, redirige a la landing — no hay
 * dashboard separado (decisión 2026-05-26: la pizarra ES la app).
 *
 * NO ESPERA A SABER SI HAY SESIÓN, Y ESO ES DELIBERADO
 * ----------------------------------------------------
 * Antes enseñaba un cargador mientras se comprobaba la sesión. Con la API
 * respondiendo en 30 ms nadie lo veía nunca, así que parecía gratis. El
 * 2026-08-23, con la API inalcanzable, se vio lo que costaba de verdad: la
 * página de entrar se quedaba cargando indefinidamente. La pantalla que existe
 * para arreglar un problema de acceso era la que dejaba de funcionar.
 *
 * Ahora el formulario se pinta de inmediato y la redirección ocurre cuando (y
 * si) se confirma que hay sesión. El caso normal de quien abre /login es no
 * tenerla; el otro ve el formulario un instante antes de que se le redirija,
 * que es una molestia mínima comparada con una pantalla en blanco.
 *
 * La regla general que deja esto: una pantalla pública no debe depender de una
 * llamada al servidor para dibujarse.
 * =============================================================================
 */

import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/components/providers/AuthProvider'

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { session } = useAuth()

  if (session) return <Navigate to="/" replace />

  return <>{children}</>
}
